var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }